export const DONATIONS_METADATA_REQUESTED =
  'account-detail/DONATIONS_METADATA_REQUESTED';
export const DONATIONS_METADATA_SUCCESS =
  'account-detail/DONATIONS_METADATA_SUCCESS';
export const DONATIONS_METADATA_FAILURE =
  'account-detail/DONATIONS_METADATA_FAILURE';
export const DONATIONS_LIST_DATA_REQUESTED =
  'account-detail/DONATIONS_LIST_DATA_REQUESTED';
export const DONATIONS_LIST_DATA_SUCCESS =
  'account-detail/DONATIONS_LIST_DATA_SUCCESS';
export const DONATIONS_LIST_DATA_FAILURE =
  'account-detail/DONATIONS_LIST_DATA_FAILURE';
export const DONATIONS_TOGGLE_COLUMNS_CHANGE =
  'account-detail/DONATIONS_COLUMNS_CHANGE';

export const FUNDRAISING_METADATA_REQUESTED =
  'account-detail/FUNDRAISING_METADATA_REQUESTED';
export const FUNDRAISING_METADATA_SUCCESS =
  'account-detail/FUNDRAISING_METADATA_SUCCESS';
export const FUNDRAISING_METADATA_FAILURE =
  'account-detail/FUNDRAISING_METADATA_FAILURE';
export const FUNDRAISING_LIST_DATA_REQUESTED =
  'account-detail/FUNDRAISING_LIST_DATA_REQUESTED';
export const FUNDRAISING_LIST_DATA_SUCCESS =
  'account-detail/FUNDRAISING_LIST_DATA_SUCCESS';
export const FUNDRAISING_LIST_DATA_FAILURE =
  'account-detail/FUNDRAISING_LIST_DATA_FAILURE';
export const FUNDRAISING_TOGGLE_COLUMNS_CHANGE =
  'account-detail/TOGGLE_COLUMNS_CHANGE';

export const GET_DETAIL_REQUESTED = 'account-detail/GET_REQUESTED';
export const GET_DETAIL_SUCCESS = 'account-detail/GET_SUCCESS';
export const GET_DETAIL_FAILURE = 'account-detail/GET_FAILURE';

export const DONATION_SUMMARY_REPORT_REQUESTED =
  'account-detail/DONATION_SUMMARY_REPORT_REQUESTED';
export const DONATION_SUMMARY_REPORT_SUCCESS =
  'account-detail/DONATION_SUMMARY_REPORT_SUCCESS';
export const DONATION_SUMMARY_REPORT_FAILURE =
  'account-detail/DONATION_SUMMARY_REPORT_FAILURE';

export const SALES_METADATA_REQUESTED =
  'account-detail/SALES_METADATA_REQUESTED';
export const SALES_METADATA_SUCCESS =
  'account-detail/SALES_METADATA_SUCCESS';
export const SALES_METADATA_FAILURE =
  'account-detail/SALES_METADATA_FAILURE';
export const SALES_LIST_DATA_REQUESTED =
  'account-detail/SALES_LIST_DATA_REQUESTED';
export const SALES_LIST_DATA_SUCCESS =
  'account-detail/SALES_LIST_DATA_SUCCESS';
export const SALES_LIST_DATA_FAILURE =
  'account-detail/SALES_LIST_DATA_FAILURE';
export const SALES_TOGGLE_COLUMNS_CHANGE =
  'account-detail/SALES_COLUMNS_CHANGE';

export const DONATION_SUBSCRIPTIONS_METADATA_REQUESTED =
  'account-detail/DONATION_SUBSCRIPTIONS_METADATA_REQUESTED';
export const DONATION_SUBSCRIPTIONS_METADATA_SUCCESS =
  'account-detail/DONATION_SUBSCRIPTIONS_METADATA_SUCCESS';
export const DONATION_SUBSCRIPTIONS_METADATA_FAILURE =
  'account-detail/DONATION_SUBSCRIPTIONS_METADATA_FAILURE';
export const DONATION_SUBSCRIPTIONS_LIST_DATA_REQUESTED =
  'account-detail/DONATION_SUBSCRIPTIONS_LIST_DATA_REQUESTED';
export const DONATION_SUBSCRIPTIONS_LIST_DATA_SUCCESS =
  'account-detail/DONATION_SUBSCRIPTIONS_LIST_DATA_SUCCESS';
export const DONATION_SUBSCRIPTIONS_LIST_DATA_FAILURE =
  'account-detail/DONATION_SUBSCRIPTIONS_LIST_DATA_FAILURE';
export const DONATION_SUBSCRIPTIONS_TOGGLE_COLUMNS_CHANGE =
  'account-detail/DONATION_SUBSCRIPTIONS_COLUMNS_CHANGE';

export const PLACEHUB_APPLICATIONS_METADATA_REQUESTED =
  'account-detail/PLACEHUB_APPLICATIONS_METADATA_REQUESTED';
export const PLACEHUB_APPLICATIONS_METADATA_SUCCESS =
  'account-detail/PLACEHUB_APPLICATIONS_METADATA_SUCCESS';
export const PLACEHUB_APPLICATIONS_METADATA_FAILURE =
  'account-detail/PLACEHUB_APPLICATIONS_METADATA_FAILURE';
export const PLACEHUB_APPLICATIONS_LIST_DATA_REQUESTED =
  'account-detail/PLACEHUB_APPLICATIONS_LIST_DATA_REQUESTED';
export const PLACEHUB_APPLICATIONS_LIST_DATA_SUCCESS =
  'account-detail/PLACEHUB_APPLICATIONS_LIST_DATA_SUCCESS';
export const PLACEHUB_APPLICATIONS_LIST_DATA_FAILURE =
  'account-detail/PLACEHUB_APPLICATIONS_LIST_DATA_FAILURE';
export const PLACEHUB_APPLICATIONS_TOGGLE_COLUMNS_CHANGE =
  'account-detail/PLACEHUB_APPLICATIONS_COLUMNS_CHANGE';

export const DETAIL_STORE_CLEAR = 'account-detail/STORE_CLEAR';
export const ERROR_CLEAR = 'account-detail/ERROR_CLEAR';
export const ON_VALUE_CHANGE = 'account-detail/ON_VALUE_CHANGE';
export const DONATION_SUMMARY_MODAL_OPEN =
  'account-detail/DONATION_SUMMARY_MODAL_OPEN';

export const ACTIVE_TAB_SET = 'account-detail/ACTIVE_TAB_SET';